import ToggleSwitch from "./ToggleSwitch";

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/components/common/toggleSwitch/index.js